import styled from "styled-components";
import { Table, Input, Button, Typography } from "antd";
import {
  PRIMARY_500,
  GRAY_50,
  GRAY_500,
  GRAY_700,
  WHITE,
  BLACK,
  GRAY_100,
  GRAY_900,
  GRAY_300,
  BLUE,
  GRAY_400
} from "../../constant/colors";
import { fontWeights, sizes } from "../../constant/styles";
import { PatientViewTableStyle } from "../SavedList/PatientViewTableStyle";

const { TextArea } = Input;
const { Text } = Typography;

export const StyledTable = styled(Table)`
  ${PatientViewTableStyle}
  width: 87vw;
  margin-bottom: 24px;

  .ant-table {
    background: ${WHITE};
    border: 1px solid #e6ebf1;
    border-radius: 10px;
    table-layout: fixed;
    min-height: ${(props) => (props.isFormOpen ? `calc(100vh - 450px)` : `calc(100vh - 370px)`)};
  }

  .ant-table-container {
    border-radius: 10px;
    min-height: ${(props) => (props.isFormOpen ? `calc(100vh - 450px)` : `calc(100vh - 370px)`)};
  }

  .ant-table table {
    table-layout: fixed;
  }

  .ant-table-body {
    overflow-y: auto !important;
    overflow-x: hidden !important;

    &::-webkit-scrollbar {
      width: 8px;
    }

    &::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb {
      background: #c1c1c1;
      border-radius: 4px;

      &:hover {
        background: #a8a8a8;
      }
    }
  }

  .ant-table-thead > tr > th {
    background: ${GRAY_100};
    color: ${BLACK};
    font-weight: ${fontWeights.semibold};
    font-size: ${sizes.medium};
    line-height: 150%;
    height: 41px !important;
    border-bottom: 1px solid #e6ebf1;
    padding: 9.5px 8px;

    &::before {
      display: none !important;
    }

    &:first-child {
      border-top-left-radius: 8px;
    }

    &:last-child {
      border-top-right-radius: 8px;
    }
  }

  .ant-table-tbody > tr > td {
    padding: 8px;
    border-bottom: 1px solid #e6ebf1;
    color: #101828;
    font-size: ${sizes.medium};
    vertical-align: middle;
    word-wrap: break-word;
    word-break: break-word;
    overflow-wrap: break-word;
    max-width: 0;
  }

  .ant-table-tbody > tr:hover > td {
    background: #f9fafb;
  }

  .ant-table-tbody > tr.editing-row > td {
    padding: 8px;

    &:last-child {
      padding: 8px 8px 8px 0px;
    }
  }

  .ant-table-tbody > tr:last-child > td {
    border-bottom: none;

    &:first-child {
      border-bottom-left-radius: 8px;
    }

    &:last-child {
      border-bottom-right-radius: 8px;
    }
  }

  .ant-empty-description {
    color: ${GRAY_500};
    font-size: ${sizes.medium};
  }

  .ant-table-placeholder {
    .ant-table-cell {
      border-bottom: none;
    }
  }

  .ant-table-empty .ant-table-body {
    height: ${(props) => (props.isFormOpen ? `calc(100vh - 450px)` : `calc(100vh - 370px)`)};
  }
  .ant-table-thead > tr > th > .ant-table-column-sorters {
    justify-content: start;
    align-items: center;
  }

  .ant-table-thead > tr > th > .ant-table-column-sorters .ant-table-column-title {
    flex: initial;
  }

  .ant-table-container table > thead > tr:first-child th:first-child {
    padding: 8px 8px 10px 20px !important;
  }

  .ant-table-tbody > tr > td:first-child {
    padding: 8px 0px 8px 20px !important;
  }

  tbody > tr[aria-hidden="true"]:first-child > td {
    padding: 0px !important;
  }

  .ant-table-empty .ant-table-tbody > tr.ant-table-placeholder {
    height: ${(props) => (props.isFormOpen ? `calc(100vh - 450px)` : `calc(100vh - 370px)`)};
  }

  .ant-table-column-sorter {
    margin-top: 2px !important;
  }
`;

export const NoteContent = styled.div`
  font-weight: ${fontWeights.regular};
  color: #101828;
  font-size: ${sizes.medium};
  line-height: 20px;
  white-space: pre-line;
  word-break: break-word;
  overflow-wrap: break-word;
`;

export const ActionButtons = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: flex-end;
`;

export const ActionButton = styled(Button)`
  border-radius: 4px;
  transition: all 0.2s ease;
  background: transparent !important;
  svg {
    transition: all 0.2s ease;
  }

  &:hover {
    svg {
      rect {
        fill: ${GRAY_300};
      }

      fill: ${GRAY_300};
      path {
        fill: ${GRAY_300};
      }
    }
  }
`;

export const EditContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0;
  background: transparent;
`;

export const EditNoteHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 4px;
`;

export const EditNoteLabel = styled.div`
  font-size: ${sizes.small};
  line-height: 18px;
  font-weight: ${fontWeights.regular};
  color: ${GRAY_500};
  cursor: pointer;
`;

export const CharacterCountLabel = styled.div`
  font-size: ${sizes.small};
  line-height: 18px;
  font-weight: ${fontWeights.regular};
  color: ${GRAY_500};
`;

export const EditNoteContentWrapper = styled.div`
  display: flex;
  gap: 12px;
  align-items: flex-start;
  width: 100%;
`;

export const EditNoteTextArea = styled(TextArea)`
  resize: none;
  border-radius: 5px;
  border: 1px solid ${GRAY_400};
  padding: 10px;
  font-size: ${sizes.medium};
  line-height: 20px;
  font-family: inherit;
  color: ${GRAY_900};
  background: ${WHITE};

  textarea {
    height: 62px !important;
    min-height: 62px !important;
    max-height: 62px !important;
  }

  &:focus,
  &:hover {
    border-color: ${PRIMARY_500};
    box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.12);
    outline: none;
  }

  &::placeholder {
    color: ${GRAY_500};
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: space-between;
  margin-top: 16px;
`;

export const SaveNoteButton = styled(Button)`
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: ${fontWeights.semibold};
  font-size: ${sizes.small};

  &:disabled,
  &:hover:disabled {
    background: ${BLUE};
    opacity: 0.3;
    border: 1px solid ${BLUE};
    color: ${WHITE};
  }
`;

export const AddNoteButton = styled(Button)`
  &:disabled,
  &:hover:disabled {
    background: ${BLUE};
    opacity: 0.3;
    border: 1px solid ${BLUE};
    color: ${WHITE};
  }
`;

export const CancelEditButton = styled(Button)`
  display: flex;
  justify-content: center;
  color: ${GRAY_700};
  font-weight: ${fontWeights.semibold};
  font-size: ${sizes.small};
  border-bottom: 1.5px solid ${GRAY_700};
  border-radius: 0px;

  &.ant-btn-link {
    border-bottom: 1.5px solid ${GRAY_700};
    border-radius: 0px;
  }

  &:disabled,
  &:hover:disabled {
    opacity: 0.3;
    color: ${GRAY_700};
    border-bottom: 1.5px solid ${GRAY_700};
    border-radius: 0px;
  }

  &:hover {
    background: ${GRAY_50};
    color: ${GRAY_700};
    border-bottom: 1.5px solid ${GRAY_700};
    border-radius: 0px;
  }

  &:active,
  &:focus {
    color: ${GRAY_700};
    border-bottom: 1.5px solid ${GRAY_700};
    border-radius: 0px;
  }
`;

export const StyledEmptyText = styled(Text)`
  color: rgba(0, 0, 0, 0.4);
  font-weight: ${fontWeights.regular};
  font-size: ${sizes.medium};
`;

export const StyledEmptyDescription = styled.div`
  font-weight: ${fontWeights.regular};
  font-size: ${sizes.small};
  color: ${BLACK};
  gap: 8px;
  display: flex;
  flex-direction: column;
`;
